module.exports = __webpack_public_path__ + "static/media/kb-ambassador-es.953867d2.png";